export default __webpack_public_path__ + "static/media/icon_webinar.568f6e86.png";